<template>
  <v-card style="height: 100%">
    <v-toolbar color="primary" dark dense style="height: 40px">
      <v-row class="flex-nowrap" justify="space-between">
        <v-flex pt-1 shrink>
          <v-row align="center" justify="start" shrink>
            <v-flex shrink>
              <b>
                <h5
                  style="padding-right: 8px;"
                  v-if="invoiceDetails.driver"
                  class="nobold"
                >&nbsp {{invoiceDetails.driver.name}}</h5>
              </b>
            </v-flex>
            <v-flex shrink>
              <h5 class="nobold">
                Invoice Ref:
                <b>{{ invoiceDetails ? invoiceDetails.invoice.id : ''}}</b>
              </h5>
            </v-flex>
            <v-flex pl-2 shrink>
              <v-select
                class="typeSelect"
                v-model="typeToShow"
                :items="listType"
                item-text="name"
                item-value="value"
                text
                solo-inverted
                label
                hide-details
                style="width: 120px;"
              ></v-select>
            </v-flex>
          </v-row>
        </v-flex>
        <v-flex shrink>
          <v-row align="center" justify="end">
            <v-flex shrink pt-2>
              <v-radio-group
                v-if="typeToShow == 'jobs'"
                v-model="jobFilter"
                row
                class="radioFilter"
              >
                <v-row>
                  <v-radio label="All" value="all" color="white" />
                  <v-radio label="Card" value="card" color="white" />
                  <v-radio label="Cash" value="cash" color="white" />
                  <v-radio label="Account" value="account" color="white" />
                </v-row>
              </v-radio-group>
            </v-flex>
            <v-flex class="toolbarButton" pb-2 pl-3 :pt-3="typeToShow != 'jobs'" shrink>
              <v-row align="center" shrink>
                <v-flex pr-2 shrink>
                  <v-btn
                    class="text-none"
                    text
                    outlined
                    @click="showAddExtraDialog(invoiceDetails.invoice.id, '')"
                    :disabled="invoiceDetails.invoice.paid"
                  >Add Extra</v-btn>
                </v-flex>
                <v-flex shrink>
                  <v-btn
                    v-if="currentInvoice"
                    class="text-none"
                    text
                    outlined
                    @click="sendInvoice(invoiceDetails.invoice.id)"
                  >Send Invoice</v-btn>
                </v-flex>
              </v-row>
            </v-flex>
          </v-row>
        </v-flex>
      </v-row>
    </v-toolbar>
    <v-flex xs12 md12>
      <v-layout column v-if="typeToShow == 'jobs'" style="height: calc(100vh - 168px)">
        <v-flex xs12 md12>
          <v-data-table
            disable-pagination
            hide-default-footer
            :items="jobsToShow"
            :key="invoiceDetails.invoice.id"
            :headers="jobsHeaders"
            item-key="id"
            class="fullPageDriverTable"
          >
            <template v-slot:no-data>
              <v-flex v-if="loading" xs12 md12 pt-4 pb-4>
                <v-layout align-center justify-center>
                  <v-progress-circular indeterminate color="primary" :size="70"></v-progress-circular>
                </v-layout>
              </v-flex>
              <v-flex v-if="!loading" xs12 md12>
                <v-layout align-center justify-center>No jobs</v-layout>
              </v-flex>
            </template>
            <template v-slot:headers="jobsTableProps">
              <tr class="jobsHeader">
                <th
                  :class=" (header.value == 'spacer') ? 'jobsHeaderSpacer' : 'jobsHeader'"
                  v-for="header in jobsTableProps.headers"
                  :key="header.text"
                >{{ header.text }}</th>
              </tr>
            </template>
            <template v-slot:item="jobsTableProps">
              <tr style="width:100%">
                <td style="width:5%;" class="text-xs-left">
                  <a
                    @click.stop="goToBooking(jobsTableProps.item.booking.id)"
                  >{{ jobsTableProps.item.booking.id }}</a>
                </td>
                <td
                  style="width:4%;"
                  class="text-xs-left"
                >{{ jobsTableProps.item.booking.ref_num ? jobsTableProps.item.booking.ref_num : '—' }}</td>
                <td style="width: calc(10vw - 40px);" class="text-xs-left">
                  <div class="noTextOverflow">{{ jobsTableProps.item.booking.pickup_time }}</div>
                </td>
                <td style="width: calc(14vw - 60px);" class="text-xs-left">
                  <div class="noTextOverflow">
                    <v-icon :size="14" @click="showChangeUser(jobsTableProps.item)">edit</v-icon>
                    <span>
                      <a
                        @click.stop="goToUser(jobsTableProps.item.booking.user_id)"
                      >{{ jobsTableProps.item.booking.user_name }}</a>&nbsp;&nbsp;
                    </span>
                  </div>
                </td>
                <td class="columnSpacer"></td>
                <td style="width: calc(22vw - 85px);" class="text-xs-left">
                  <div class="noTextOverflow">{{ getPickupLocation(jobsTableProps.item) }}</div>
                </td>
                <td style="width:4%;" class="text-xs-left">
                  <v-btn
                    v-if="jobsTableProps.item.booking.destinations.length > 1"
                    text
                    color="primary"
                    @click.stop="showOtherDestinations(jobsTableProps.item.booking)"
                    class="removeButtonPadding"
                  >+{{jobsTableProps.item.booking.destinations.length - 1}}</v-btn>
                </td>
                <td style="width: 22%;" class="text-xs-left">
                  <div class="noTextOverflow">{{ getDestination(jobsTableProps.item) }}</div>
                </td>
                <td style="width:5%;" class="text-xs-left">
                  <v-edit-dialog
                    v-if="jobsTableProps.item.payment_type == 'cash' || jobsTableProps.item.payment_type == 'account'"
                    large
                    lazy
                    @save="handleUpdatePaymentType()"
                    @cancel="handleCloseEditField()"
                    @open="handleOpenChangePaymentType(jobsTableProps.item)"
                    @close="handleCloseEditField()"
                  >
                    <div>{{ getPaymentType(jobsTableProps.item.payment_type) }}</div>
                    <template v-slot:input>
                      <v-form v-model="editFieldValid">
                        <v-select
                          class="mt-2"
                          v-model="editField.paymentType"
                          :items="paymentTypes"
                          label="Change Payment Type"
                          autofocus
                        ></v-select>
                      </v-form>
                    </template>
                  </v-edit-dialog>
                  <div v-else>{{ getPaymentType(jobsTableProps.item.payment_type) }}</div>
                </td>
                <td style="width:5%;" class="text-xs-left">
                  <v-edit-dialog
                    v-if="invoiceDetails.invoice && !invoiceDetails.invoice.paid"
                    large
                    lazy
                    @save="handleUpdateFinalCost()"
                    @cancel="handleCloseEditField()"
                    @open="handleOpenEditFinalCost(jobsTableProps.item)"
                    @close="handleCloseEditField()"
                  >
                    <div>{{ formatter.format(jobsTableProps.item.booking.final_cost / 100) }}</div>
                    <template v-slot:input>
                      <v-form v-model="editFieldValid">
                        <v-text-field
                          class="mt-2"
                          v-model="editField.amount"
                          :rules="[monetaryValueValidator]"
                          label="Edit Final Cost"
                          autofocus
                          prefix="£"
                        ></v-text-field>
                      </v-form>
                    </template>
                  </v-edit-dialog>
                  <div
                    v-if="invoiceDetails.invoice.paid"
                  >{{ formatter.format(jobsTableProps.item.booking.final_cost / 100) }}</div>
                </td>
                <td style="width:5%;" class="text-xs-left">
                  <v-edit-dialog
                    v-if="invoiceDetails.invoice && !invoiceDetails.invoice.paid"
                    large
                    lazy
                    @save="handleUpdateDriverPay()"
                    @cancel="handleCloseEditField()"
                    @open="handleOpenEditDriverPay(jobsTableProps.item)"
                    @close="handleCloseEditField()"
                  >
                    <div>{{ formatter.format(jobsTableProps.item.cost / 100) }}</div>
                    <template v-slot:input>
                      <v-form v-model="editFieldValid">
                        <v-text-field
                          class="mt-2"
                          v-model="editField.amount"
                          :rules="[monetaryValueValidator]"
                          label="Edit Driver Pay"
                          autofocus
                          prefix="£"
                        ></v-text-field>
                      </v-form>
                    </template>
                  </v-edit-dialog>
                  <div
                    v-if="invoiceDetails.invoice.paid"
                  >{{ formatter.format(jobsTableProps.item.cost / 100) }}</div>
                </td>
                <td style="width:6%;" class="text-xs-left">
                  <v-edit-dialog
                    v-if="!invoiceDetails.invoice.paid"
                    large
                    lazy
                    @save="handleUpdateCommission()"
                    @cancel="handleCloseEditField()"
                    @open="handleOpenEditCommission(jobsTableProps.item)"
                    @close="handleCloseEditField()"
                  >
                    <v-row>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            class="moveIconToEnd"
                            small
                            @click.stop="resetCommissionDialog = true; resetCommissionID = jobsTableProps.item.booking.id;"
                            v-on="on"
                            v-if="jobsTableProps.item.overriden_charge == true"
                          >settings_backup_restore</v-icon>
                        </template>
                        <span>Reset Commission</span>
                      </v-tooltip>
                      {{ formatter.format(jobsTableProps.item.charge / 100) }}
                    </v-row>
                    <template v-slot:input>
                      <v-form v-model="editFieldValid">
                        <v-text-field
                          class="mt-2"
                          v-model="editField.amount"
                          :rules="[monetaryValueValidator]"
                          label="Edit Commission"
                          autofocus
                          prefix="£"
                        ></v-text-field>
                      </v-form>
                    </template>
                  </v-edit-dialog>
                  <div
                    v-if="invoiceDetails.invoice.paid"
                  >{{ formatter.format(jobsTableProps.item.charge / 100) }}</div>
                </td>
                <td style="width:5%;" class="text-xs-left">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        small
                        @click.stop="showAddExtraDialog(invoiceDetails.invoice.id, jobsTableProps.item.booking.id)"
                        v-on="on"
                        :disabled="invoiceDetails.invoice.paid"
                      >add</v-icon>
                    </template>
                    <span>Add Extra</span>
                  </v-tooltip>
                  <v-tooltip v-if="jobsTableProps.item.hasExtras" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small @click.stop="typeToShow = 'extras'" v-on="on">visibility</v-icon>
                    </template>
                    <span>View Extras</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:footer v-if="showJobsLoader" class="jobsLoader">
              <td :colspan="jobsHeaders.length">
                <v-layout align-center justify-center>
                  <v-progress-circular
                    v-observe-visibility="{
                      callback: loadMoreJobs,
                      throttle: 300
                    }"
                    :size="25"
                    :width="2"
                    color="blue"
                    indeterminate
                  ></v-progress-circular>
                </v-layout>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md12>
      <v-layout column v-if="typeToShow == 'extras'" style="height: 90%">
        <v-flex xs12 md12>
          <v-data-table
            :items="extrasWithBooking"
            :key="invoiceDetails.invoice.id"
            :headers="extrasHeaders"
            item-key="id"
            :class="currentInvoice ? 'fullPageDriverTable' : (driverTable ? 'halfPageDriverTable' : 'summaryTable')"
          >
            <template v-slot:no-data>
              <v-flex v-if="loading" xs12 md12 pt-4 pb-4>
                <v-layout align-center justify-center>
                  <v-progress-circular indeterminate color="primary" :size="70"></v-progress-circular>
                </v-layout>
              </v-flex>
              <v-flex v-if="!loading" xs12 md12>
                <v-layout align-center justify-center>No Extras</v-layout>
              </v-flex>
            </template>
            <template v-slot:headers="extrasTableProps">
              <tr class="extrasHeader">
                <th
                  class="extrasHeader"
                  v-for="header in extrasTableProps.headers"
                  :key="header.text"
                >{{ header.text }}</th>
              </tr>
            </template>
            <template v-slot:item="extrasTableProps">
              <tr>
                <td style="width:10%;" class="text-xs-left">{{ extrasTableProps.item.id }}</td>
                <td
                  style="width:13%;"
                  class="text-xs-left"
                >{{ getTimeForExtra(extrasTableProps.item.date) }}</td>
                <td style="width:25%;" class="text-xs-left">{{ extrasTableProps.item.description }}</td>
                <td
                  style="width:25%;"
                  class="text-xs-left"
                >{{ extrasTableProps.item.driverDescription }}</td>
                <td style="width:9%;" class="text-xs-left">{{ extrasTableProps.item.booking_id }}</td>
                <td
                  style="width:8%;"
                  class="text-xs-left"
                >{{ formatter.format(extrasTableProps.item.charge/100) }}</td>
                <td
                  style="width:8%;"
                  class="text-xs-left"
                >{{ extrasTableProps.item.credit ? 'Credit' : 'Debit' }}</td>
                <td style="width:2%;" class="text-xs-left">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        small
                        @click.stop="removeExtraDialog = true; removeExtraID = extrasTableProps.item.id"
                        v-on="on"
                        :disabled="invoiceDetails.invoice.paid"
                      >delete</v-icon>
                    </template>
                    <span>Remove Extra</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex style="background-color: #eaeaea; height: 72px;" py-3>
      <v-row justify="space-between">
        <v-flex shrink>
          <v-row style="padding-left: 6px; padding-right: 6px;">
            <v-flex pt-1 shrink>
              <v-col>
                <p style="font-size: 12px; color: grey;">Cash</p>
                <p>
                  <b>{{ formatMoneyValue(invoiceDetails.invoice.totals.cash) }}</b>
                </p>
              </v-col>
            </v-flex>
            <v-flex pt-1 pl-1 shrink>
              <v-col>
                <p style="font-size: 12px; color: grey;">Card</p>
                <p>
                  <b>{{ formatMoneyValue(invoiceDetails.invoice.totals.card) }}</b>
                </p>
              </v-col>
            </v-flex>
            <v-flex pt-1 pl-1 shrink>
              <v-col>
                <p style="font-size: 12px; color: grey;">Account</p>
                <p>
                  <b>{{ formatMoneyValue(invoiceDetails.invoice.totals.account) }}</b>
                </p>
              </v-col>
            </v-flex>
            <v-flex pt-1 pl-1 shrink>
              <v-col>
                <p style="font-size: 12px; color: grey;">Fees</p>
                <p>
                  <b>{{ formatMoneyValue(invoiceDetails.invoice.totals.serviceFee) }}</b>
                </p>
              </v-col>
            </v-flex>
            <v-flex pt-1 pl-1 shrink>
              <v-col>
                <p style="font-size: 12px; color: grey;">Charges</p>
                <p>
                  <b>{{ formatMoneyValue(invoiceDetails.invoice.totals.charges) }}</b>
                </p>
              </v-col>
            </v-flex>
            <v-flex pt-1 pl-1 shrink>
              <v-col>
                <p style="font-size: 12px; color: grey;">Payable</p>
                <p
                  :class="getPayableColour(invoiceDetails.invoice.id, invoiceDetails.invoice.totals.payable)"
                >
                  <b>{{ formatMoneyValue(invoiceDetails.invoice.totals.payable) }}</b>
                </p>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>

        <v-flex shrink pr-3 pt-1>
          <v-row>
            <v-flex pr-2>
              <ChangeCommissionDialog
                @commissionChanged="commissionChanged"
                :invoiceDetails="invoiceDetails"
              ></ChangeCommissionDialog>
            </v-flex>
            <v-btn
              color="green lighten-2"
              class="text-none"
              dark
              @click.stop="startClearInvoice(invoiceDetails.invoice, (invoiceDetails.driver != null ? invoiceDetails.driver.id : null))"
            >Mark As Paid</v-btn>
          </v-row>
        </v-flex>
      </v-row>
    </v-flex>
    <v-dialog persistent v-model="resetCommissionDialog" :width="450">
      <v-card>
        <v-card-title primary-title class="headline warning lighten-1">
          <v-layout align-center justify-center>
            <span class="title font-weight-light white--text" style="line-height: 18pt !important;">
              Are you sure you want to reset commission for booking:
              <b>{{resetCommissionID}}</b>?
            </span>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn color="red darken-1" text outlined @click="resetCommission()">Yes</v-btn>
            <v-btn
              color="blue darken-1"
              text
              outlined
              @click="handleCloseResetCommissionDialog()"
            >No</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="removeExtraDialog" :width="550">
      <v-card>
        <v-card-title primary-title class="headline warning lighten-1">
          <v-layout align-center justify-center>
            <span class="title font-weight-light white--text" style="line-height: 18pt !important;">
              Are you sure you want remove this extra, reference:
              <b>{{removeExtraID}}</b>?
            </span>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-layout row justify-end>
            <v-btn color="red darken-1" text outlined @click="removeExtra()">Yes</v-btn>
            <v-btn color="blue darken-1" text outlined @click="handleCloseRemoveExtraDialog()">No</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="journeyDialog" :width="450">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-1">
          <v-layout align-center justify-center>
            <span class="title font-weight-light white--text" style="line-height: 18pt !important;">
              Journey for booking:
              <b>{{journeyBooking.id}}</b>
            </span>
          </v-layout>
        </v-card-title>
        <v-flex px-3 py-2>
          <v-timeline dense>
            <v-timeline-item fill-dot icon="emoji_people">
              <v-flex pa-2>
                <h5 class="nobold grey--text text--darken-1">Pickup Location:</h5>
                <h4 class="nobold">{{journeyBooking.pickup_location}}</h4>
              </v-flex>
            </v-timeline-item>
            <v-timeline-item
              v-for="(destination, index) in journeyBooking.destinations"
              :key="destination.id"
              fill-dot
              small
              v-if="index > 0"
            >
              <v-flex pa-2>
                <h4 class="nobold">{{destination.description}}</h4>
              </v-flex>
            </v-timeline-item>
            <v-timeline-item
              v-if="journeyBooking != null && journeyBooking.destinations != null && journeyBooking.destinations.length > 0"
              :key="journeyBooking.destinations[0].id"
              fill-dot
              :icon="'room'"
            >
              <v-flex pa-2>
                <h5 class="nobold grey--text text--darken-1">Final Destination:</h5>
                <h4 class="nobold">{{journeyBooking.destinations[0].description}}</h4>
              </v-flex>
            </v-timeline-item>
          </v-timeline>
        </v-flex>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn text @click="journeyDialog = false">Close</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="changeUserDialog" :width="450">
      <v-card v-if="changeUserJob.booking != null">
        <v-card-title primary-title class="headline grey lighten-1">
          <v-layout align-center justify-center>
            <span class="title font-weight-light white--text" style="line-height: 18pt !important;">
              Change User for booking:
              <b>{{changeUserJob.booking.id}}</b>
            </span>
          </v-layout>
        </v-card-title>
        <v-flex px-3 py-2>
          <v-flex xs12>
            <v-autocomplete
              v-model="customer"
              :items="customers"
              :loading="loading"
              :search-input.sync="search"
              item-text="name"
              label="Customer Search*"
              hide-no-data
              hide-selected
              no-filter
              return-object
              @change="customerSelected"
              required
            ></v-autocomplete>
          </v-flex>
        </v-flex>
        <v-card-actions>
          <v-layout row justify-end>
            <v-btn color="red darken-1" text @click="changeUserDialog = false">Cancel</v-btn>
            <v-btn color="green darken-1" text @click="changeUser">Update</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AddExtra
      :showDialog="addExtraDialog"
      :invoiceID="addExtraInvoiceID"
      :bookingID="addExtraBookingID"
      @closeAddExtra="closeAddExtraDialog"
      @addExtra="addExtra($event)"
    />
  </v-card>
</template>

<script>
import ChangeCommissionDialog from "@/components/invoices/ChangeCommissionDialog.vue";
import AddExtra from "@/components/invoices/AddExtra.vue";
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "job_list",
  props: {
    invoiceDetails: Object,
    loading: Boolean,
    currentInvoice: {
      type: Boolean,
      default: false
    },
    driverTable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AddExtra,
    ChangeCommissionDialog
  },
  data: function() {
    return {
      changeUserDialog: false,
      changeUserJob: {},
      customers: [],
      customer: {},
      search: null,
      typeToShow: "jobs",
      jobFilter: "all",
      jobsToShow: [],
      editField: {
        amount: "",
        bookingID: -1,
        paymentType: null
      },
      paymentTypes: ["cash", "account"],
      editFieldValid: true,
      monetaryValueValidator: v =>
        /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
      journeyDialog: false,
      journeyBooking: {},
      resetCommissionDialog: false,
      resetCommissionID: -1,
      addExtraDialog: false,
      addExtraInvoiceID: -1,
      addExtraBookingID: -1,
      removeExtraDialog: false,
      removeExtraID: -1,
      listType: [
        {
          name: "Jobs",
          value: "jobs"
        },
        {
          name: "Extras",
          value: "extras"
        }
      ],
      jobsHeaders: [
        {
          text: "Booking",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Business Ref.",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "datetime"
        },
        {
          text: "Customer Name",
          align: "left",
          sortable: false,
          value: "user_name"
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "spacer"
        },
        {
          text: "Pickup",
          align: "left",
          sortable: false,
          value: "pickup_location"
        },
        {
          text: "Via",
          align: "left",
          sortable: false,
          value: "via"
        },
        {
          text: "Destination",
          align: "left",
          sortable: false,
          value: "destination"
        },
        {
          text: "Type",
          align: "center",
          sortable: false,
          value: "payment_type"
        },
        {
          text: "Final Cost",
          align: "center",
          sortable: false,
          value: "final_cost"
        },
        {
          text: "Driver Pay",
          align: "center",
          sortable: false,
          value: "cost"
        },
        {
          text: "Fee",
          align: "left",
          sortable: false,
          value: "charge"
        },
        {
          text: "Extras",
          align: "center",
          sortable: false,
          value: "charge"
        }
      ],
      extrasHeaders: [
        {
          text: "Reference",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "time"
        },
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: "Driver Description",
          align: "left",
          sortable: false,
          value: "driverDescription"
        },
        {
          text: "Booking",
          align: "left",
          sortable: false,
          value: "booking"
        },
        {
          text: "Amount",
          align: "left",
          sortable: false,
          value: "charge"
        },
        {
          text: "Credit/Debit",
          align: "left",
          sortable: false,
          value: "credit"
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "remove"
        }
      ],
      formatter: Function,
      noSignFormatter: Function
    };
  },
  beforeMount: function() {
    this.formatter = new Intl.NumberFormat("en-UK", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2
    });

    this.noSignFormatter = new Intl.NumberFormat("en-UK", {
      style: "decimal",
      minimumFractionDigits: 2
    });
  },
  methods: {
    commissionChanged: function(driverId, invoiceId, invoice) {
      this.$emit("commissionChanged", driverId, invoiceId, invoice);
    },
    startClearInvoice: function(invoiceId, driverId) {
      this.$emit("startClearInvoice", invoiceId, driverId);
    },
    formatMoneyValue: function(value) {
      if (value == 0) {
        return "—";
      } else {
        return this.formatter.format(value / 100);
      }
    },
    getPayableColour: function(invoiceID, payable) {
      if (payable < 0) {
        return "red--text";
      } else {
        return "green--text text--darken-2";
      }
    },
    showChangeUser: function(job) {
      this.changeUserJob = job;
      this.changeUserDialog = true;
    },
    changeUser: async function() {
      this.changeUserDialog = false;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/changeUser?booking_id=${this.changeUserJob.booking.id}&user_id=${this.customer.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        if (response.data.error == "no_error") {
          alert("Booking User updated");
          this.changeUserJob.booking.user = this.customer;
          this.changeUserJob.booking.user_name = this.customer.name;
          this.changeUserJob.booking.user_id = this.customer.id;
          this.changeUserJob = {};
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown error");
      }
    },
    customerSelected: function(customer) {
      console.log("Changed " + JSON.stringify(customer));
    },
    searchCompleted: function(data) {
      this.customers = data.customers;

      this.loading = false;
    },
    getPickupLocation: function(job) {
      let location = job.booking.pickup_location;
      return location;
    },
    getDestination: function(job) {
      let destinations = job.booking.destinations;
      if (destinations.length > 0) {
        let lastDestination = destinations[0];
        return lastDestination.description;
      } else {
        return "No destination";
      }
    },
    getPaymentType: function(type) {
      if (type == "card_in_cab") {
        return "Card in Cab";
      } else {
        return type.charAt(0).toUpperCase() + type.slice(1);
      }
    },
    getTimeForExtra: function(datetime) {
      let parsedDate = new Date(datetime);
      let datetimeString =
        parsedDate.getDate() +
        "/" +
        (parsedDate.getMonth() + 1) +
        "/" +
        parsedDate.getFullYear() +
        " " +
        parsedDate.getHours() +
        ":" +
        parsedDate.getMinutes();

      return datetimeString;
    },
    handleUpdatePaymentType: function() {
      if (this.editFieldValid) {
        this.$emit("updatePaymentType", this.editField);
      } else {
        this.$emit(
          "errorSnackbar",
          "Failed to change payment type - please select a payment type"
        );
      }
    },
    handleUpdateFinalCost: function() {
      if (this.editFieldValid) {
        this.$emit("setFinalCost", this.editField);
      } else {
        this.$emit(
          "errorSnackbar",
          "Failed to edit final cost, please enter a valid amount"
        );
      }
    },
    handleUpdateDriverPay: function() {
      if (this.editFieldValid) {
        this.$emit("setDriverPay", this.editField);
      } else {
        this.$emit(
          "errorSnackbar",
          "Failed to edit driver pay, please enter a valid amount"
        );
      }
    },
    handleOpenChangePaymentType: function(job) {
      if (!this.invoiceDetails.invoice.paid) {
        this.editField.paymentType = job.booking.payment_type;
        this.editField.bookingID = job.booking.id;
      }
    },
    handleOpenEditFinalCost: function(job) {
      if (!this.invoiceDetails.invoice.paid) {
        const noSignFormatter = new Intl.NumberFormat("en-UK", {
          style: "decimal",
          minimumFractionDigits: 2
        });
        let amount = this.noSignFormatter.format(job.booking.final_cost / 100);
        this.editField.amount = amount.replace(/\,/g, "");
        this.editField.bookingID = job.booking.id;
      }
    },
    handleOpenEditDriverPay: function(job) {
      if (!this.invoiceDetails.invoice.paid) {
        const noSignFormatter = new Intl.NumberFormat("en-UK", {
          style: "decimal",
          minimumFractionDigits: 2
        });
        let amount = this.noSignFormatter.format(job.cost / 100);
        this.editField.amount = amount.replace(/\,/g, "");
        this.editField.bookingID = job.booking.id;
      }
    },
    handleUpdateCommission: function() {
      if (this.editFieldValid) {
        this.$emit("setCommission", this.editField);
      } else {
        this.$emit(
          "errorSnackbar",
          "Failed to edit commission, please enter a valid amount"
        );
      }
    },
    handleOpenEditCommission: function(job) {
      if (!this.invoiceDetails.invoice.paid) {
        let amount = this.noSignFormatter.format(job.charge / 100);
        this.editField.amount = amount.replace(/\,/g, "");
        this.editField.bookingID = job.booking.id;
      }
    },
    handleCloseEditField: function() {
      //this.editField.amount = "";
      this.editField.bookingID = -1;
    },
    handleCloseResetCommissionDialog: function() {
      this.resetCommissionDialog = false;
      let self = this;
      this.$nextTick(function() {
        self.resetCommissionID = -1;
      });
    },
    handleCloseRemoveExtraDialog: function() {
      this.removeExtraDialog = false;
      let self = this;
      this.$nextTick(function() {
        self.removeExtraID = -1;
      });
    },
    resetCommission: function() {
      this.$emit("resetCommission", this.resetCommissionID);
      this.handleCloseResetCommissionDialog();
    },
    showAddExtraDialog: function(invoiceID, bookingID) {
      this.addExtraInvoiceID = invoiceID;
      this.addExtraBookingID = bookingID;
      this.addExtraDialog = true;
    },
    closeAddExtraDialog: function() {
      this.addExtraDialog = false;
      this.addExtraInvoiceID = -1;
      this.addExtraBookingID = -1;
    },
    addExtra: function(payload) {
      this.$emit("addExtra", payload);
    },
    removeExtra: function() {
      this.$emit("removeExtra", this.removeExtraID);
      this.handleCloseRemoveExtraDialog();
    },
    loadMoreJobs: function() {
      let numToAdd = this.filteredJobs.length - this.jobsToShow.length;
      if (numToAdd > 20) {
        numToAdd = 20;
      }

      let newJobs = JSON.parse(JSON.stringify(this.jobsToShow));
      for (let i = 0; i < numToAdd; i++) {
        newJobs.push(this.filteredJobs[this.jobsToShow.length + i]);
      }

      this.jobsToShow = newJobs;
    },
    goToUser: function(userID) {
      let routeData = this.$router.resolve(`/customer/view/${userID}`);
      window.open(routeData.href, "_blank");
    },
    goToBooking: function(bookingID) {
      let routeData = this.$router.resolve({
        path: "/bookings",
        query: { bookingID: bookingID }
      });
      window.open(routeData.href, "_blank");
    },
    showOtherDestinations(booking) {
      this.journeyBooking = booking;
      this.journeyDialog = true;
    },
    sendInvoice: function(invoiceID) {
      this.$emit("sendInvoice", invoiceID);
    }
  },
  watch: {
    "invoiceDetails.invoice.id": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.jobsToShow = [];
        this.typeToShow = "jobs";
        this.jobFilter = "all";
      }
    },
    search(val) {
      console.log(val);

      if (val == null) return;
      if (val.length <= 1) return;

      var url = `${this.$store.state.apiUrl}/customer/search?query=${val}`;

      var searchCompleted = this.searchCompleted;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          searchCompleted(res.data);
        })
        .catch(function(err) {
          console.error(err);
          this.loading = false;
        });
    }
  },
  computed: {
    filteredJobs: function() {
      let jobs = this.invoiceDetails.invoice.jobs;
      let filtered;
      if (this.jobFilter != "all") {
        let filters = {};

        switch (this.jobFilter) {
          case "card":
            filters = {
              card: true,
              card_in_cab: true,
              cash: false,
              account: false
            };
            break;
          case "cash":
            filters = {
              card: false,
              card_in_cab: false,
              cash: true,
              account: false
            };
            break;
          case "account":
            filters = {
              card: false,
              card_in_cab: false,
              cash: false,
              account: true
            };
            break;
        }

        filtered = jobs.filter(function(job) {
          return filters[job.payment_type];
        });
      } else {
        filtered = jobs;
      }

      let extraJobIDs = {};
      for (let j = 0; j < this.invoiceDetails.invoice.extras.length; j++) {
        extraJobIDs[
          this.invoiceDetails.invoice.extras[j].invoice_job_id
        ] = true;
      }

      for (let i = 0; i < filtered.length; i++) {
        let hasExtras = extraJobIDs[filtered[i].id] ? true : false;
        filtered[i] = {
          ...filtered[i],
          hasExtras: hasExtras
        };
      }

      this.jobsToShow = filtered;
      return filtered;
    },
    extrasWithBooking: function() {
      let self = this;
      //copy
      let extras = JSON.parse(
        JSON.stringify(this.invoiceDetails.invoice.extras)
      );

      for (let i = 0; i < extras.length; i++) {
        let bookingID = "";
        if (extras[i].invoice_job_id) {
          self.invoiceDetails.invoice.jobs.forEach(function(job) {
            if (job.id == extras[i].invoice_job_id) {
              bookingID = job.booking.id;
            }
          });

          extras[i] = {
            ...extras[i],
            booking_id: bookingID
          };
        }
      }

      return extras;
    },
    showJobsLoader: function() {
      if (this.jobsToShow.length == this.filteredJobs.length) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style>
.nobold {
  font-weight: normal;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 18px !important;
}

.v-data-table td {
  font-size: 13px !important;
  height: 19px !important;
}

table.v-table tbody tr td a {
  text-decoration: none;
}

.summaryTable {
  min-height: calc(50vh - 40px - 6px);
  max-height: calc(50vh - 40px - 6px);
  overflow-y: auto;
}

.jobsHeader {
  height: 30px !important;
  padding: 2px 18px !important;
}

.jobsHeaderSpacer {
  padding: 0 !important;
  margin: 0 !important;
  width: 0 !important;
  font-size: 0 !important;
  overflow: hidden;
}

.columnSpacer {
  padding: 0 !important;
  margin: 0 !important;
  width: 0 !important;
  font-size: 0 !important;
  overflow: hidden;
}

.jobsLoader {
  justify-content: center !important;
}

.extrasHeader {
  height: 30px !important;
}

.summaryTable {
  min-height: calc(50vh - 40px - 6px);
  max-height: calc(50vh - 40px - 6px);
  overflow-y: auto;
}

.fullPageDriverTable {
  min-height: calc(100vh - 80px - 40px - 10px - 150px);
  max-height: calc(100vh - 80px - 40px - 10px - 150px);
  table-layout: fixed;
  overflow-y: auto;
}

.halfPageDriverTable {
  min-height: calc(50vh - 40px - 40px - 8px);
  max-height: calc(50vh - 40px - 40px - 8px);
  table-layout: fixed;
  overflow-y: auto;
}

.typeSelect {
  transform: scale(0.6);
  transform-origin: left;
  max-width: 120px;
}

.toolbarDivider {
  margin-top: 6px !important;
  height: 40px !important;
}

.radioFilter {
  transform: scale(0.8);
  transform-origin: left;
}

.toolbarButton {
  transform: scale(0.9);
  transform-origin: left;
}

.radioBoxToEnd {
  padding-left: calc(33vw - 260px) !important;
}

.moveIconToEnd {
  padding-right: 5px;
}

.removeButtonPadding {
  min-width: 0;
  padding-right: 3px;
  padding-left: 3px;
  margin: 0;
  border-radius: 0;
  height: 20px;
}

.noTextOverflow {
  overflow: hidden;
  height: 19px;
}

.cell {
  box-sizing: border-box;
  display: block;
  width: 100%;
}

.v-data-table td,
.v-data-table th {
  padding: 0 6px !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.col {
  padding: 0px 16px !important;
}
</style>
